export const inspectTable = [
  {
    id: 1,
    isChecked: '',
    content: [
      '안전보건관리체계 구축 및 이행', '중처법 시행령 제4조', '안전보건관리책임자, 관리감독자의 충실한 업무수행(반기1회점검)',
      '중대재해예방 및 조칙체계 구축'
    ],
  },
  {
    id: 2,
    isChecked: '',
    content: [
      '안전보건관리체계 구축 및 이행', '중처법 시행령 제4조', '안전보건관리책임자, 관리감독자의 충실한 업무수행(반기1회점검)',
      '안전보건관리(총괄)책임자 지정'
    ],
  },
  {
    id: 3,
    isChecked: '',
    content: [
      '안전보건관리체계 구축 및 이행', '중처법 시행령 제4조', '안전보건관리책임자, 관리감독자의 충실한 업무수행(반기1회점검)',
      '관리감독자 지정'
    ],
  },
  {
    id: 4,
    isChecked: '',
    content: [
      '안전보건관리체계 구축 및 이행', '중처법 시행령 제4조', '안전보건관리책임자, 관리감독자의 충실한 업무수행(반기1회점검)',
      '안전관리자 및 보건관리자 지정'
    ],
  },
  {
    id: 5,
    isChecked: '',
    content: [
      '안전보건관리체계 구축 및 이행', '중처법 시행령 제6조', '안전보건관리책임자, 관리감독자의 충실한 업무수행(반기1회점검)',
      '안전보건관리(총괄)책임자 의무교육 이수'
    ],
  },
  {
    id: 6,
    isChecked: '',
    content: [
      '안전보건관리체계 구축 및 이행', '중처법 시행령 제6조', '안전보건관리책임자, 관리감독자의 충실한 업무수행(반기1회점검)',
      '관리감독자 의무교육 이수'
    ],
  },
  {
    id: 7,
    isChecked: '',
    content: [
      '안전보건관리체계 구축 및 이행', '중처법 시행령 제6조', '종사자 의견청취 절차 마련(반기1회 점검)',
      '안전관리자 및 보건관리자 의무교육 이수'
    ],
  },
  {
    id: 8,
    isChecked: '',
    content: [
      '안전보건관리체계 구축 및 이행', '중처법 시행령 제4조 제7호', '재해 발생대비 매뉴얼 마련 및 조치(반기1회 점검)',
      '산업안전보건위원회 운영 및 근로자 의견청취'
    ],
  },
  {
    id: 9,
    isChecked: '',
    content: [
      '안전보건관리체계 구축 및 이행', '중처법 시행령 제4조 제8호', '재해 발생대비 매뉴얼 마련 및 조치(반기1회 점검)',
      '안전보건 관리계획 수립 및 이행(종합계획 수립)'
    ],
  },
  {
    id: 10,
    isChecked: '',
    content: [
      '안전보건관리체계 구축 및 이행', '중처법 시행령 제5조', '안전보건 관계법령상 의무이행 조치(반기1회 점검)',
      '부서(동)별 산재예방계획 수립'
    ],
  },
  {
    id: 11,
    isChecked: '',
    content: [
      '안전보건관리체계 구축 및 이행', '중처법 시행령 제5조', '안전보건 관계법령상 의무이행 조치(반기1회 점검)',
      '안전·보건 비전 및 경영방침 게시'
    ],
  },
  {
    id: 12,
    isChecked: '',
    content: [
      '안전보건관리체계 구축 및 이행', '중처법 시행령 제5조', '안전보건 관계법령상 의무이행 조치(반기1회 점검)',
      '위험성평가 실시 및 위험성 감소대책 시행\n(연1회)'
    ],
  },
  {
    id: 13,
    isChecked: '',
    content: [
      '안전보건관리체계 구축 및 이행', '중처법 시행령 제5조', '안전보건 관계법령상 의무이행 조치(반기1회 점검)',
      '종사자의 건강진단(일반·특수) 실시'
    ],
  },
  {
    id: 14,
    isChecked: '',
    content: [
      '안전보건관리체계 구축 및 이행', '중처법 시행령 제5조', '안전보건 관계법령상 의무이행 조치(반기1회 점검)',
      '작업환경 측정 실시'
    ],
  },
  {
    id: 15,
    isChecked: '',
    content: [
      '안전보건관리체계 구축 및 이행', '중처법 시행령 제5조', '안전보건 관계법령상 의무이행 조치(반기1회 점검)',
      '근골격계유해요인조사 실시 및 개선조치'
    ],
  },
  {
    id: 16,
    isChecked: '',
    content: [
      '안전보건관리체계 구축 및 이행', '중처법 시행령 제5조', '안전보건 관계법령상 의무이행 조치(반기1회 점검)',
      '안전보건교육(신규채용시·정기·특별) 실시'
    ],
  },
  {
    id: 17,
    isChecked: '',
    content: [
      '안전보건관리체계 구축 및 이행', '중처법 시행령 제5조', '안전보건 관계법령상 의무이행 조치(반기1회 점검)',
      '안전보건 예산 편성 및 집행'
    ],
  },
  {
    id: 18,
    isChecked: '',
    content: [
      '안전보건관리체계 구축 및 이행', '중처법 시행령  제4조 제9호', '<span class="underline">도급·용역·위탁 분야</span> 안전보건 관리체계 마련 및 이행',
      '(도급) 안전보건 점검(합동·순회)'
    ],
  },
  {
    id: 19,
    isChecked: '',
    content: [
      '안전보건관리체계 구축 및 이행', '중처법 시행령  제4조 제9호', '<span class="underline">도급·용역·위탁 분야</span> 안전보건 관리체계 마련 및 이행',
      '(도급) 관계수급인의 안전보건의무 이행 지도·감독'
    ],
  },
  {
    id: 20,
    isChecked: '',
    content: [
      '안전보건관리체계 구축 및 이행', '중처법 시행령  제4조 제9호', '<span class="underline">도급·용역·위탁 분야</span> 안전보건 관리체계 마련 및 이행',
      '(발주공사) 건설재해예방지도기관으로부터 기술지도'
    ],
  },
];
